import React from 'react';
import { View } from 'react-native-web';
import LayoutBar from './LayoutBar';
import RegularText from '../Text/RegularText';

//= ========================================================================

const LayoutContainer = ({
  globJSON,
  onConfigChanged,
  object,
}) => {
  const isSelected = globJSON.configurations.services.menu.icon_shape_bars_enam === object.value;
  return (
    <View>
      <RegularText>{object.text}</RegularText>
      <LayoutBar globJSON={globJSON} onConfigChanged={onConfigChanged} iconShape={object.value} isSelected={isSelected} />
    </View>
  );
};
export default LayoutContainer;
